import { render, staticRenderFns } from "./MessageLoading.vue?vue&type=template&id=e6b4c236&scoped=true&"
import script from "./MessageLoading.vue?vue&type=script&lang=js&"
export * from "./MessageLoading.vue?vue&type=script&lang=js&"
import style0 from "./MessageLoading.vue?vue&type=style&index=0&id=e6b4c236&scoped=true&lang=css&"
import style1 from "./MessageLoading.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b4c236",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/q7gCdwre/0/h5group/renpho-lex/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6b4c236')) {
      api.createRecord('e6b4c236', component.options)
    } else {
      api.reload('e6b4c236', component.options)
    }
    module.hot.accept("./MessageLoading.vue?vue&type=template&id=e6b4c236&scoped=true&", function () {
      api.rerender('e6b4c236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MessageLoading.vue"
export default component.exports